export let addToFavoritesDesc = "gzppfb";
export let archiveButtonDesc = "dtCfId";
export let assignPolicyButtonDesc = "M9WoTd";
export let blockButtonDesc = "CE1mRb";
export let browseGroupsButtonDesc = "lHjvz";
export let neverBlockButtonDesc = "agMVmc";
export let categorizeButtonDesc = "w5JQrc";
export let createRuleButtonDesc = "VIFFXc";
export let customizeButtonDesc = "CVdg$";
export let deleteButtonDesc = "Uaj9F";
export let discardButtonDesc = "ZvsDAc";
export let deleteEmptyFolderButtonDesc = "zhVEEb";
export let flagButtonDesc = "dYqvdd";
export let flagClearFlagButtonDesc = "iCXTYb";
export let flagNextWeekButtonDesc = "mpMGw";
export let flagNoDateButtonDesc = "eN_ecc";
export let flagThisWeekButtonDesc = "noCNpb";
export let flagTodayButtonDesc = "ugSIRb";
export let flagTomorrowButtonDesc = "A3tJX";
export let flagCustomButtonDesc = "gh1M1b";
export let flagAddReminderButtonDesc = "gg2lIe";
export let flagEditReminderButtonDesc = "jZQR3d";
export let flagMarkCompleteButtonDesc = "hvjrdc";
export let forwardButtonDesc = "AveHx";
export let forwardEmailAsAttachmentDesc = "ZpxI5";
export let getAddinsButtonDesc = "UuVODe";
export let getMessageExtensionsButtonDesc = "oNVHle";
export let getM365AppsButtonDesc = "wh9ezd";
export let ignoreButtonDesc = "NLZuwb";
export let immersiveReaderButtonDesc = "Vl$w5c";
export let junkButtonDesc = "zBJRoe";
export let manageRulesButtonDesc = "PsXX3c";
export let moreRetentionPoliciesButtonDesc = "w5eJX";
export let moveButtonDesc = "kVEfhc";
export let newMessageButtonDesc = "KjYDj";
export let newItemsButtonDesc = "btmuTc";
export let newFolderPostButtonDesc = "rG6Zzd";
export let phishingButtonDesc = "H9iTk";
export let pinButtonDesc = "YzVDdc";
export let readUnreadButtonDesc = "_EZ5Cb";
export let replyButtonDesc = "ltmaR";
export let replyAllButtonDesc = "Ymp2tb";
export let replyWithMeetingButtonDesc = "O5oded";
export let copilotReplyWithMeetingButtonDesc = "ahokCd";
export let rulesButtonDesc = "oIp6Mb";
export let sendDraftButtonDesc = "wzvKbd";
export let sensitivityButtonDesc = "UoulWc";
export let sensitivityLearnMoreButtonDesc = "F9LvT";
export let snoozeButtonDesc = "p3Y8le";
export let sweepButtonDesc = "tk62Kd";
export let undoButtonDesc = "VeZmEb";
export let deleteNoteDesc = "AU6vf";
export let changeNoteColorDesc = "mPELQc";
export let viewEmailFromNotesDesc = "XWM8re";
export let layoutDesc = "RyRE_";
export let messagesDesc = "PU8OIb";
export let viewSettingsDesc = "LEV$Cb";
export let conversationsDesc = "xVvxPb";
export let classicIndentedViewDesc = "VM_xMb";
export let messagePreviewDesc = "a7v7Ee";
export let folderPaneDesc = "NawIie";
export let readingPaneDesc = "FjQnMe";
export let densityDesc = "XmOINc";
export let markAllAsReadDesc = "hjmTo";
export let manageQuickStepsDesc = "eckUGb";
export let viewGroupsPanelButtonDesc = "ijr3ne";
export let setupQuickStepsDesc = "AvdhUc";
export let restoreDesc = "fhpBmc";
export let restoreAllDesc = "oXZcib";
export let remindersWindowDesc = "s4YrM";
export let printEmailDesc = "ol0yRd";
export let messageRecallDesc = "fg9Iic";
export let expandCollapseConversationDesc = "ROncw";
export let zoomDesc = "gTtzjd";
export let ribbonModeDesc = "ejzitd";
export let trackReadReceiptsDesc = "TGb5Rd";
export let syncMailboxDesc = "urvgVd";
export let sendReceiveAllFoldersDesc = "M$v2Hc";
export let workOfflineDesc = "nrVmvd";
export let searchHighlightingDesc = "DFjKbb";
export let chatAroundEmail = "lI9Sqb";
export let chatAroundEmailAll = "MwtiBe";
export let resendDesc = "sxeI8c";
export let shareToTeamsChat = "W2bYBd";
export let myDayButtonDesc = "zh7xWd";
export let lightRPDesc = "JJEqN";
export let chatAroundEmailSplit = "lKy6ae";
export let createQuickStepDesc = "gSWKde";
export let focusedInboxToggleDesc = "CuwjZd";
export default {addToFavoritesDesc,archiveButtonDesc,assignPolicyButtonDesc,blockButtonDesc,browseGroupsButtonDesc,neverBlockButtonDesc,categorizeButtonDesc,createRuleButtonDesc,customizeButtonDesc,deleteButtonDesc,discardButtonDesc,deleteEmptyFolderButtonDesc,flagButtonDesc,flagClearFlagButtonDesc,flagNextWeekButtonDesc,flagNoDateButtonDesc,flagThisWeekButtonDesc,flagTodayButtonDesc,flagTomorrowButtonDesc,flagCustomButtonDesc,flagAddReminderButtonDesc,flagEditReminderButtonDesc,flagMarkCompleteButtonDesc,forwardButtonDesc,forwardEmailAsAttachmentDesc,getAddinsButtonDesc,getMessageExtensionsButtonDesc,getM365AppsButtonDesc,ignoreButtonDesc,immersiveReaderButtonDesc,junkButtonDesc,manageRulesButtonDesc,moreRetentionPoliciesButtonDesc,moveButtonDesc,newMessageButtonDesc,newItemsButtonDesc,newFolderPostButtonDesc,phishingButtonDesc,pinButtonDesc,readUnreadButtonDesc,replyButtonDesc,replyAllButtonDesc,replyWithMeetingButtonDesc,copilotReplyWithMeetingButtonDesc,rulesButtonDesc,sendDraftButtonDesc,sensitivityButtonDesc,sensitivityLearnMoreButtonDesc,snoozeButtonDesc,sweepButtonDesc,undoButtonDesc,deleteNoteDesc,changeNoteColorDesc,viewEmailFromNotesDesc,layoutDesc,messagesDesc,viewSettingsDesc,conversationsDesc,classicIndentedViewDesc,messagePreviewDesc,folderPaneDesc,readingPaneDesc,densityDesc,markAllAsReadDesc,manageQuickStepsDesc,viewGroupsPanelButtonDesc,setupQuickStepsDesc,restoreDesc,restoreAllDesc,remindersWindowDesc,printEmailDesc,messageRecallDesc,expandCollapseConversationDesc,zoomDesc,ribbonModeDesc,trackReadReceiptsDesc,syncMailboxDesc,sendReceiveAllFoldersDesc,workOfflineDesc,searchHighlightingDesc,chatAroundEmail,chatAroundEmailAll,resendDesc,shareToTeamsChat,myDayButtonDesc,lightRPDesc,chatAroundEmailSplit,createQuickStepDesc,focusedInboxToggleDesc};